import React, { memo } from 'react';
import PropTypes from 'prop-types';
import * as S from './ItemDetailStyles';

function ItemDetail({ label, value, separator = false }) {
  return (
    value && (
      <S.Wrapper separator={separator}>
        <S.Label>{label}</S.Label>
        <S.Value>{value}</S.Value>
      </S.Wrapper>
    )
  );
}

ItemDetail.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  separator: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default memo(ItemDetail);
